import React, { useEffect, useState } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useSelector } from 'react-redux';
const NoteItem = _ref => {
  let {
    note,
    removeNote,
    editNote,
    index
  } = _ref;
  const [editedNote, setEditedNote] = useState(note);
  const [isEditing, setIsEditing] = useState(false);
  const user = useSelector(state => state.auth.user);
  const handleChange = e => {
    setEditedNote({
      ...editedNote,
      'content': e.target.value
    });
  };
  const handleNoteEdit = async () => {
    await editNote(editedNote, index);
    setIsEditing(false);
  };
  const closeEditingForm = () => {
    setEditedNote(note);
    setIsEditing(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", null, note.author), /*#__PURE__*/React.createElement(Row, {
    key: note.id,
    className: "pb-1"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    style: {
      backgroundColor: 'lightBlue'
    },
    className: "mx-3"
  }, isEditing ? /*#__PURE__*/React.createElement(Form.Control, {
    size: "md",
    type: "text",
    onChange: handleChange,
    value: editedNote.content
  }) : /*#__PURE__*/React.createElement("span", null, note.content), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'grey'
    }
  }, note.formatted_created_at)), isEditing ? /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    className: "p-1 d-inline-flex rounded-circle",
    onClick: () => closeEditingForm()
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18",
    style: {
      color: 'firebrick'
    }
  }, "close")), note.author_id === user.id && /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    className: "p-1 d-inline-flex rounded-circle",
    onClick: () => handleNoteEdit()
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 text-success rounded-circle mx-auto"
  }, "done"))) : /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, note.author_id === user.id && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    className: "p-1 d-inline-flex rounded-circle",
    onClick: () => removeNote(note.id)
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons text-danger"
  }, "delete")), /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    className: "p-1 d-inline-flex rounded-circle",
    onClick: () => setIsEditing(true)
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 text-info rounded-circle mx-auto"
  }, "edit"))))));
};
export default NoteItem;